export default __webpack_public_path__ + "static/media/trash_over.b41342fe.svg";